<template>
<tr>
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">Available</th>
    <td class="sheet-cell text-center" v-for="(day, index) in inventory" :key="index">
        <v-progress-circular v-if="loading_date == day.date" size="12" width="2" indeterminate />
        <input v-else v-model.lazy="day.count" class="sheet-input" @change="save(day)" type="number" />
    </td>
</tr>
</template>

<script>
import {
    mapActions
} from 'vuex';
export default {
    props: {
        inventory: Object,
        backup_sheet: [Object, Array],
        params: Object
    },

    data() {
        return {
            edited_days: [],
            loading_date: null
        }
    },

    mounted() {},

    methods: {

        ...mapActions('alert', ['success', 'error']),

        save(day) {
            this.loading_date = day.date;
            let inventory = {};
            inventory[day.room_type_id] = {};
            inventory[day.room_type_id][day.date] = {
                count: day.count
            };
            let query_params = {};

            query_params.hotel_id = this.params.hotel_id;
            query_params.date_start = this.params.date_start;
            query_params.date_stop = this.params.date_stop;
            query_params.inventory = inventory;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/sheet';


            this.$axios.post(endpoint, query_params)
                .then(response => {
                    this.success(this.$t('sheet.message_update'));
                    this.backup_sheet.inventory[day.room_type_id][day.date].count = day.count;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                    this.inventory[day.date].count = this.backup_sheet.inventory[day.room_type_id][day.date].count;
                })
                .finally(() => {
                    this.loading_date = null;
                });
        },

    }
}
</script>
<style lang="stylus">
.sheet-cell
    input[type="number"]
        width: -webkit-fill-available
        -moz-appearance: textfield
        &::-webkit-outer-spin-button
            -webkit-appearance: none
            margin: auto
        &::-webkit-inner-spin-button
            -webkit-appearance: none
            margin: auto
</style>
